// @ts-nocheck
import React from "react"
import { Plus, Upload } from "lucide-react"
import Button from "../common/Button.jsx"

export default function CustomersHeader({
    onNewCustomerClick = () => { },
    onImportCustomersClick = () => { },
    actionsSlot = null,
    disableNewCustomer = false,
    disableImportCustomers = false,
    disabledTooltip = "Cannot perform this action while offline.",
}) {
    return (
        <div
            className={
                "d-flex flex-column flex-sm-row justify-content-between " +
                "align-items-start align-items-sm-center mb-4"
            }
        >
            <h1 className="fs-2 fw-bold text-dark">Customers</h1>
            <div className="d-flex gap-2 mt-3 mt-sm-0">
                {actionsSlot}
                {disableImportCustomers ? (
                    <span className="d-inline-block" title={disabledTooltip}>
                        <Button variant="outline" size="sm" disabled>
                            <span className="me-2"><Upload size={16} /></span>
                            Import Customers
                        </Button>
                    </span>
                ) : (
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={onImportCustomersClick}
                    >
                        <span className="me-2"><Upload size={16} /></span>
                        Import Customers
                    </Button>
                )}
                {disableNewCustomer ? (
                    <span className="d-inline-block" title={disabledTooltip}>
                        <Button variant="custom" size="sm" disabled>
                            <span className="me-2"><Plus size={16} /></span>
                            New Customer
                        </Button>
                    </span>
                ) : (
                    <Button
                        variant="custom"
                        size="sm"
                        onClick={onNewCustomerClick}
                    >
                        <span className="me-2"><Plus size={16} /></span>
                        New Customer
                    </Button>
                )}
            </div>
        </div>
    )
}
